export default "__VITE_ASSET__39fac978__"